module.exports = __webpack_public_path__ + "static/Calendar-Booking-1-5283c6db461d006d16f1f6e205953f8e.png";